import { en } from './en';
import type { Dict } from '../types';

export const hu: Dict = {
  ...en,
  'chat.amrCard.switchTitle': 'Sikertelen modellhívás — ez a futtatás szünetel',
  'chat.amrCard.switchBody': 'Válts az Design App hivatalos AMR modellszolgáltatására — nincs szükség API-kulcs beállítására. Bejelentkezés, engedélyezés és feltöltés után ez a futtatás automatikusan újraindul.',
  'chat.amrCard.chipOfficial': 'Hivatalos szolgáltatás',
  'chat.amrCard.chipNoKey': 'Nincs API-kulcs',
  'chat.amrCard.chipAutoRetry': 'Automatikus újrapróbálkozás bejelentkezés után',
  'chat.amrCard.switchCta': 'Váltás AMR-re és újrapróbálkozás',
  'chat.amrError.authMessage': 'Az AMR-fiókod még nincs engedélyezve. Engedélyezd, és ez a futtatás automatikusan újraindul.',
  'chat.amrError.balanceMessage': 'Az AMR-egyenleged elfogyott. Tölts fel a futtatás folytatásához.',
  'chat.amrError.authorizeCta': 'Engedélyezés és újrapróbálkozás',
  'chat.amrError.rechargeCta': 'AMR feltöltése',
  'plugins.actions.copyInstallCommand': 'Telepítési parancs másolása',
  'plugins.actions.copyPluginId': 'Pluginazonosító másolása',
  'plugins.actions.copyReadmeBadge': 'README jelvény másolása',
  'plugins.actions.openSourceGithub': 'Forrás megnyitása GitHubon',
  'plugins.actions.openSource': 'Forrás megnyitása',
  'plugins.actions.openHomepage': 'Honlap megnyitása',
  'plugins.actions.openMarketplace': 'Megnyitás a piactéren',
  'workingDirPicker.title': "Folder",
  'workingDirPicker.homeTitle': "Choose where this project should live",
  'workingDirPicker.processing': "Processing…",
  'workingDirPicker.select': "Choose working directory",
  'workingDirPicker.clearAria': "Clear working directory",
  'workingDirPicker.replaceFailed': "Could not replace working directory",
  'workingDirPicker.unavailable': "Folder picker is unavailable in this build. Run the desktop app to pick a folder.",
  'workingDirPicker.openUnavailable': "Open this project in the desktop app to show the folder.",
  'workingDirPicker.openFailed': "Could not show this folder",
  'workingDirPicker.showInFileManager': "Show in file manager",
  'workingDirPicker.replace': "Clear and replace directory…",
  'workingDirPicker.recent': "Recent directories",
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'homeHero.promptExamples': "Példák",
  'homeHero.footer.designSystem': "Stílus",
  'homeHero.footer.autoDesignSystem': "Auto",
  'homeHero.footer.autoDesignSystemSummary': "Automatikusan kiválasztja az aktuális prompthoz illő designrendszert és vizuális stílust.",
  'homeHero.footer.ratio': "Arány",
  'homeHero.footer.duration': "Időtartam",
  'homeHero.footer.resolution': "Felbontás",
  'homeHero.footer.speakerNotes': "Notes",
  'homeHero.footer.noSpeakerNotes': "Nincs jegyzet",
  'homeHero.footer.availableCount': "{n} available",
  'homeHero.footer.noMatches': "No matches",
  'homeHero.moreShortcuts': "Továbbiak",
  'common.cancel': 'Mégse',
  'common.save': 'Mentés',
  'common.close': 'Bezárás',
  'common.delete': 'Törlés',
  'common.rename': 'Átnevezés',
  'common.edit': 'Szerkesztés',
  'common.preview': 'Előnézet',
  'common.share': 'Megosztás',
  'common.search': 'Keresés',
  'common.searchEllipsis': 'Keresés…',
  'common.loading': 'Betöltés…',
  'common.all': 'Összes',
  'common.none': 'Nincs',
  'common.default': 'Alapértelmezett',
  'common.installed': 'telepítve',
  'common.notInstalled': 'nincs telepítve',
  'common.active': 'aktív',
  'common.offline': 'offline',
  'common.selected': 'kiválasztva',
  'common.create': 'Létrehozás',
  'common.openPreview': 'Előnézet megnyitása',
  'common.exitFullscreen': 'Kilépés a teljes képernyőből',
  'common.fullscreen': 'Teljes képernyő',
  'common.openInNewTab': 'Megnyitás új lapon',
  'common.exportPdf': 'Exportálás PDF-ként',
  'common.exportZip': 'Letöltés .zip-ként',
  'common.exportHtml': 'Exportálás önálló HTML-ként',
  'common.justNow': 'az imént',
  'common.minutesAgo': '{n} perce',
  'common.hoursAgo': '{n} órája',
  'common.daysAgo': '{n} napja',
  'common.weeksAgo': '{n}w ago',
  'common.now': 'most',
  'common.minutesShort': '{n}p',
  'common.hoursShort': '{n}ó',
  'common.daysShort': '{n}n',
  'common.untitled': 'Cím nélkül',

  'app.brand': 'Design App',
  'app.brandPill': 'Kutatási előzetes',
  'app.brandSubtitle': 'a Design App-tól',
  'app.welcomeLoading': 'Munkaterület betöltése…',

  'settings.welcomeKicker': "",
  'settings.welcomeTitle': "Welcome",
  'settings.welcomeSubtitle': "",
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody':
    'Describe the site, app, deck, image, or video you want. Design App will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody':
    'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody':
    'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose how generation runs',
  'settings.onboardingExecutionBody':
    'Official CLI with one-click setup and ready-to-use defaults. Use one key to choose from many models with better pricing.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Hivatalosan karbantartott',
  'settings.onboardingAmrCloudBenefitReady': 'Azonnal használható',
  'settings.onboardingAmrCloudBenefitModels': 'Sok modell',
  'settings.onboardingAmrCloudBenefitPricing': 'Kedvezőbb ár',
  'settings.onboardingAmrCloudAuthorizeAction': 'AMR engedélyezése',
  'settings.onboardingAmrCloudAuthorizedAction': 'Engedélyezve',
  'settings.onboardingStepConnect': "Connect",
  'settings.onboardingStepDesignSystem': "Design system",
  'settings.onboardingStepProfile': "About you",
  'settings.onboardingConnectTitle': "Choose a runtime",
  'settings.onboardingConnectBody': "",
  'settings.onboardingRecommended': "Recommended",
  'settings.onboardingLocalTitle': "Local coding agent",
  'settings.onboardingLocalBody': "Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.",
  'settings.onboardingLocalAction': "Open CLI settings",
  'settings.onboardingCliScanHint': "This usually takes 5-10 seconds.",
  'settings.onboardingByokTitle': "Bring your own key",
  'settings.onboardingByokBody': "Use your own model provider credentials.",
  'settings.onboardingByokAction': "Open BYOK settings",
  'settings.onboardingDesignTitle': "Design system",
  'settings.onboardingDesignBody': "Generate once, reuse everywhere.",
  'settings.onboardingDesignIntroGenerateTitle': "Generate from existing work",
  'settings.onboardingDesignIntroGenerateBody': "Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.",
  'settings.onboardingDesignIntroReuseTitle': "Reuse in future work",
  'settings.onboardingDesignIntroReuseBody': "Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.",
  'settings.onboardingDesignIntroSkipTitle': "Optional for now",
  'settings.onboardingDesignIntroSkipBody': "Skip this step if you want to start without generating a design system.",
  'settings.onboardingGithubTitle': "Import from GitHub",
  'settings.onboardingGithubBody': "Use a frontend repository.",
  'settings.onboardingUploadTitle': "Upload local files",
  'settings.onboardingUploadBody': "Add project files, screenshots, CSS, docs, or assets.",
  'settings.onboardingPromptTitle': "Generate from prompt",
  'settings.onboardingPromptBody': "Describe the product or brand.",
  'settings.onboardingProfileTitle': "About you",
  'settings.onboardingProfileBody': "Optional details for better defaults.",
  'settings.onboardingRoleLabel': "Your role",
  'settings.onboardingOrgSizeLabel': "Organization size",
  'settings.onboardingUseCaseLabel': "Use case",
  'settings.onboardingSourceLabel': "Where did you hear about us?",
  'settings.onboardingSelectPlaceholder': "Select one",
  'settings.onboardingSelectMultiplePlaceholder': "Select one or more",
  'settings.onboardingOrgSolo': "Solo / personal (1)",
  'settings.onboardingOrgTeam': "Small team (2-10)",
  'settings.onboardingOrgStartup': "Startup / SMB (11-50)",
  'settings.onboardingOrgGrowth': "Growth company (51-200)",
  'settings.onboardingOrgMidMarket': "Mid-market (201-1000)",
  'settings.onboardingOrgEnterprise': "Enterprise (1000+)",
  'settings.onboardingRolePm': "📋 Product manager",
  'settings.onboardingRoleDesigner': "🎨 Designer",
  'settings.onboardingRoleEngineer': "💻 Engineer",
  'settings.onboardingRoleMarketing': "📣 Marketing",
  'settings.onboardingRoleGrowth': "📈 Growth",
  'settings.onboardingRoleOps': "⚙️ Operations",
  'settings.onboardingRoleFounder': "🚀 Founder / executive",
  'settings.onboardingRoleStudent': "🎓 Student / educator",
  'settings.onboardingRoleOther': "✨ Other",
  'settings.onboardingUseProduct': "🎨 Product design",
  'settings.onboardingUseDesignSystem': "🧩 Design system",
  'settings.onboardingUsePrototype': "📱 Prototype / app UI",
  'settings.onboardingUseLanding': "🌐 Landing pages",
  'settings.onboardingUseAds': "📣 Ads / social content",
  'settings.onboardingUseDashboard': "📊 Dashboards / internal tools",
  'settings.onboardingUseDeck': "🖥️ Presentation / deck",
  'settings.onboardingUseMarketing': "📈 Marketing / growth",
  'settings.onboardingUseEngineering': "🤝 Engineering handoff",
  'settings.onboardingUseAgency': "💼 Agency / client work",
  'settings.onboardingSourceGithub': "🐙 GitHub",
  'settings.onboardingSourceFriend': "👥 Friend or coworker",
  'settings.onboardingSourceSocial': "📱 Social media",
  'settings.onboardingSourceProductHunt': "🅿️ Product Hunt",
  'settings.onboardingSourceCommunity': "💬 Design / AI community",
  'settings.onboardingSourceYoutube': "▶️ YouTube",
  'settings.onboardingSourceBlog': "📰 Blog or newsletter",
  'settings.onboardingSourceAiTool': "✨ AI tool recommendation",
  'settings.onboardingSourceSearch': "🔍 Search",
  'settings.onboardingSourceEvent': "🎤 Event or community",
  'settings.onboardingBack': "Back",
  'settings.onboardingContinue': "Continue",
  'settings.onboardingFinish': "Finish setup",
  'settings.onboardingSkip': "Skip for now",
  'settings.kicker': 'Beállítások',
  'settings.title': 'Végrehajtási mód',
  'settings.subtitle': 'Válassz helyi CLI és BYOK között.',
  'settings.modeAria': 'Végrehajtási mód',
  'settings.protocolAria': 'API protokoll',
  'settings.modeDaemon': 'Helyi CLI',
  'settings.modeDaemonHelp': 'Futtatás a gépeden lévő code-agent CLI-n keresztül',
  'settings.modeDaemonOffline': 'A daemon nem fut',
  'settings.modeDaemonOfflineMeta': 'a daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} telepítve',
  'settings.modeApi': 'API-szolgáltató',
  'settings.modeApiMeta': 'BYOK',
  'settings.codeAgent': 'Code agent',
  'settings.codeAgentHint':
    'A PATH átvizsgálásával észlelve. Válaszd ki a CLI-t, amelyen át a generálásokat szeretnéd futtatni.',
  'settings.rescan': '↻ Újraellenőrzés',
  'settings.rescanTitle': 'PATH újraellenőrzése',
  'settings.rescanRunning': 'Ellenőrzés...',
  'settings.rescanSuccess': 'Ellenőrzés kész. {count} elérhető.',
  'settings.designSystemRenameFailed': 'Az átnevezés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.rescanFailed': 'Az ellenőrzés sikertelen. Ellenőrizd a daemont, majd próbáld újra.',
  'settings.test': 'Teszt',
  'settings.testTitle': 'Küldj egy apró tesztkérdést a kapcsolat ellenőrzéséhez',
  'settings.testRunning': 'Kapcsolat tesztelése…',
  'settings.testCancel': 'Mégse',
  'settings.testSuccessApi': 'Csatlakozva. Válasz {ms} ms alatt — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} {ms} ms alatt válaszolt — \'{sample}\'',
  'settings.testAuthFailed': 'A hitelesítés sikertelen. Ellenőrizd az API kulcsot.',
  'settings.testForbidden': 'A hozzáférés tiltott. Ellenőrizd a fiókot, régiót vagy szervezetet.',
  'settings.testNotFoundModel': 'A(z) \'{model}\' modell nem található ezen a végponton.',
  'settings.testInvalidModelId': 'A(z) \'{model}\' modellazonosító érvénytelen. Az egyéni azonosító betűvel vagy számmal kezdődjön, és ne tartalmazzon szóközt.',
  'settings.testInvalidBaseUrl': 'A Base URL érvénytelen vagy nem elérhető.',
  'settings.testRateLimited': 'A szolgáltató korlátozta a tesztet. A konfiguráció érvényesnek tűnik.',
  'settings.testUpstream': 'A szolgáltató {status} kódot adott vissza. Próbáld újra rövidesen.',
  'settings.testTimeout': 'A teszt {ms} ms után időtúllépéssel megszakadt.',
  'settings.testAgentMissing': 'A(z) {agentName} nincs telepítve vagy nincs a PATH-ban.',
  'settings.testAgentSpawn': 'Nem sikerült elindítani: {agentName} — {detail}.',
  'settings.testUnknown': 'Sikertelen teszt: {detail}',
  'settings.agentInstall.install': 'Telepítés',
  'settings.agentInstall.docs': 'Dokumentáció',
  'settings.agentInstall.pathHint':
    'Ha npm-mel vagy Homebrew-val telepítettél egy CLI-t, de továbbra is nincs telepítve állapotban látszik, ellenőrizd, hogy az eszköz bin könyvtára benne van-e abban a PATH-ban, amit az Design App daemon örököl (macOS-en a Terminal és a GUI appok PATH-ja eltérhet). Lásd a QUICKSTART.md "Local agent CLI and PATH" szakaszát.',
  'settings.agentInstall.stepOpenLinks': 'Nyisd meg a Telepítés vagy Dokumentáció hivatkozást a kívánt ügynöknél.',
  'settings.agentInstall.stepAuth':
    'Hitelesíts a szolgáltató CLI-jében (bejelentkezés vagy API hitelesítő adatok megadása), mielőtt visszatérsz az Design Apphoz.',
  'settings.agentInstall.stepRescan': 'Kattints az Újraellenőrzés gombra ebben a szakaszban.',
  'settings.agentInstall.stepSelect': 'Válaszd ki az ügynök kártyáját, amint telepítettként jelenik meg.',
  'settings.noAgentsDetected':
    'Még nincs észlelt ügynök. Telepítsd a Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen vagy GitHub Copilot CLI valamelyikét, majd kattints az Újraellenőrzésre.',
  'settings.agentInstalledGroup': 'Saját CLI-k ({count})',
  'settings.agentInstallGroup': 'Telepíthető ({count})',
  'settings.agentAuthRequired': 'Hitelesítés szükséges',
  'settings.agentAuthUnknown': 'A hitelesítési állapot ismeretlen',
  'settings.amrLogin': 'Sign in',
  'settings.amrLogout': 'Sign out',
  'settings.amrLoggingIn': 'Signing in…',
  'settings.amrLoggingOut': 'Signing out…',
  'settings.amrLoggedInAs': 'Signed in as {email}',
  'settings.amrLoggedInWithPlan': 'Signed in as {email} · {plan}',
  'settings.amrLoggedInPill': 'Signed in',
  'settings.amrNotLoggedIn': 'Not signed in',
  'settings.amrCloud': 'Design App AMR',
  'settings.amrAuthorize': 'Authorize',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Many models',
  'settings.amrPromoBonus': 'Limited bonus: +100%',
  'settings.amrSignInToContinue': 'Sign in to continue',
  'settings.amrSignIn': 'Sign in',
  'settings.amrSignedIn': 'Signed in',
  'settings.amrNotSignedIn': 'Not signed in',
  'settings.amrSigningIn': 'Signing in…',
  'settings.amrCancelSignIn': 'Cancel sign-in',
  'settings.amrAccountStatus': 'AMR account status',
  'settings.amrLoginErrorCompact': 'AMR sign-in failed.',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Szolgáltató gyors kitöltése',
  'settings.customProvider': 'Egyéni szolgáltató',
  'settings.apiKey': 'API-kulcs',
  'settings.showKey': 'Kulcs megjelenítése',
  'settings.hideKey': 'Kulcs elrejtése',
  'settings.show': 'Megjelenítés',
  'settings.hide': 'Elrejtés',
  'settings.model': 'Modell',
  'settings.suggestedModelsHint':
    'Ezek a protokollhoz javasolt modellek. A szolgáltatód más modelleket is támogathat.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Adj meg egy érvényes nyilvános http:// vagy https:// URL-t. A localhost engedélyezett; a privát hálózati IP-k blokkolva vannak.',
  'settings.baseUrlCustomize': 'Testreszabás',
  'settings.baseUrlDefaultHint': 'Alapértelmezett végpont. Általában nem kell módosítani.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'Deployment név',
  'settings.azureDeploymentModelHint':
    'Azure OpenAI esetén ez a mező a /openai/deployments/<model> deployment neveként szerepel. Add meg az Azure-ban létrehozott deployment nevét.',
  'settings.apiVersion': 'API-verzió',
  'settings.byokImageModel': 'Képgenerálási modell',
  'settings.maxTokens': 'Max tokenek (opcionális)',
  'settings.maxTokensHint':
    'A válasz hosszának felső határa. Minden modellnek van hangolt alapértelmezése (placeholderként látható); hagyd üresen az alkalmazásához, vagy adj meg számot a felülíráshoz.',
  'settings.apiHint': 'A hívások a helyi daemon proxyn keresztül mennek a beállított Base URL-re. A kulcs csak ebben a böngészőben tárolódik, és a szolgáltatói kérésekkel együtt kerül elküldésre.',
  'settings.skipForNow': 'Most kihagyom',
  'settings.getStarted': 'Kezdjük',
  'settings.envConfigure': 'Végrehajtási mód',
  'settings.localCli': 'Helyi CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'nincs kiválasztott ügynök',
  'settings.language': 'Nyelv',
  'settings.languageHint': 'A felület nyelvének váltása. Ebben a böngészőben mentve.',
  'settings.appearance': 'Megjelenés',
  'settings.appearanceHint': 'Válassz világos, sötét, vagy kövesd a rendszer beállítását.',
  'settings.themeSystem': 'Rendszer',
  'settings.themeLight': 'Világos',
  'settings.themeDark': 'Sötét',
  'settings.agentModelHead': 'Modell ehhez:',
  'settings.modelPicker': 'Modell',
  'settings.modelSourceLive': 'Élőben a CLI-ből',
  'settings.modelSourceFallback': 'Beépített lista',
  'settings.reasoningPicker': 'Gondolkodási erőfeszítés',
  'settings.modelPickerHint':
    'A CLI-tól kérdezi le, ha az közzéteszi a `models` parancsot. Az „Alapértelmezett" a CLI saját konfigjára bízza a választást; az „Egyedi…" tetszőleges, a CLI által elfogadott modell-id-t enged megadni.',
  'settings.modelPickerLiveHint':
    'A modellek frissültek a telepített CLI-ből. Az Alapértelmezett továbbra is a CLI konfigurációját használja.',
  'settings.modelPickerFallbackHint':
    'A beépített alapértékek láthatók. Kattints az Újraellenőrzésre az élő CLI-modellek lekéréséhez.',
  'settings.cliEnvTitle': 'CLI config locations',
  'settings.cliEnvHint':
    'Set non-secret config directories for packaged app runs and agent detection.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code config directory',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude proxy API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex executable path',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI proxy API key',
  'settings.modelCustom': 'Egyedi (gépeld be alább)…',
  'settings.modelCustomLabel': 'Egyedi modell-id',
  'settings.modelCustomPlaceholder': 'pl. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Média-szolgáltatók',
  'settings.mediaProvidersHint':
    'API-kulcsok kép-, videó- és hanggeneráláshoz. Helyben tárolva, és a helyi daemonnal szinkronizálva.',
  'settings.mcpServerTitle': 'MCP-szerver',
  'settings.mcpServerHint': 'Tedd elérhetővé az Design Appt MCP-szerverként a kódügynököd számára.',
  'settings.externalMcpTitle': 'Külső MCP',
  'settings.externalMcpHint': 'Adj hozzá MCP-eszközöket külső szolgáltatásokból (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-kulcs',
  'settings.mediaProviderBaseUrl': 'Bázis URL',
  'settings.mediaProviderConfigured': 'Beállítva',
  'settings.mediaProviderUnset': 'Nincs beállítva',
  'settings.mediaProviderClear': 'Törlés',
  'settings.mediaProviderClearConfirm': 'Törölni szeretnéd a mentett {name} beállításokat? A {name} használatához újra meg kell adnod azokat.',
  'settings.mediaProviderPlaceholder': 'API-kulcs beillesztése',
  'settings.mediaProviderBaseUrlPlaceholder': 'Alapértelmezett bázis URL felülírása',
  'settings.mediaProviderReload': 'Újratöltés a helyi démonból',
  'settings.mediaProviderReloadError': 'Nem sikerült újratölteni a médiaszolgáltatók beállításait a helyi démonból.',
  'settings.mediaProviderReloadSuccess': 'A médiaszolgáltatók beállításai újra lettek töltve a helyi démonból.',
  'settings.mediaProviderLoadError': 'Nem sikerült betölteni a médiaszolgáltatók beállításait a helyi démonból. Egyelőre a böngészőben mentett beállításokat használjuk.',
  'settings.mediaProviderComingSoonHint': 'Ezeket nyomon követjük az ütemtervben; a daemon még nem szállít klienst, így nincs mit konfigurálni.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the Design App team',
  'settings.privacyConsentKicker': 'Help us improve Design App',
  'settings.privacyConsentLead': 'Design App can share usage data with our team to help us improve. This includes:',
  'settings.privacyConsentFooter': 'You can change either of these any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentShare': 'Share usage data',
  'settings.privacyConsentDecline': "Don't share",
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter':
    'Data sharing is on by default. You can turn it off any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, duration. No prompts, no project data.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': "Your prompts and the assistant's responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.",
  'settings.privacyArtifacts': 'Project artifacts manifest',
  'settings.privacyArtifactsHint': 'Filenames, types, sizes of generated files. File contents are never sent.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'Névjegy',
  'settings.aboutHint': 'Verzió- és futtatókörnyezeti adatok',
  'settings.appVersion': 'Verzió',
  'settings.appChannel': 'Csatorna',
  'settings.appRuntime': 'Futtatókörnyezet',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Architektúra',
  'settings.runtimePackaged': 'Csomagolt alkalmazás',
  'settings.runtimeDevelopment': 'Fejlesztői',
  'settings.versionUnavailable': 'A verzió adatai nem érhetők el, amíg a daemon offline.',
  'settings.installLatest': 'Legújabb verzió telepítése',
  'settings.alreadyLatest': 'Ön már a legújabb verziót használja',

  'entry.tabDesigns': 'Tervek',
  'entry.tabTemplates': 'Sablonok',
  'entry.tabDesignSystems': 'Designrendszerek',
  'entry.tabConnectors': 'Kapcsolók',
  'entry.openSettingsTitle': 'Beállítások',
  'entry.openSettingsAria': 'Beállítások megnyitása',
  'entry.resizeAria': 'Oldalsáv átméretezése',
  'entry.loadingWorkspace': 'Munkaterület betöltése…',
  'entry.useEverywhereTitle': 'Használat bárhol',
  'entry.useEverywhereAria': '„Használat bárhol” útmutató megnyitása (CLI, MCP, HTTP, Skills)',
  'entry.navNewProject': 'Új projekt',
  'entry.navHome': 'Kezdőlap',
  'entry.navProjects': 'Projektek',
  'entry.navDesignSystems': 'Tervezőrendszerek',
  'entry.helpAria': 'Súgó',
  'entry.helpMenuAria': 'Súgó menü',
  'entry.helpGetHelp': 'Kérj segítséget a GitHubon',
  'entry.helpSubmitFeature': 'Funkció javaslása',
  'entry.helpWhatsNew': 'Újdonságok',
  'entry.helpDownloadDesktop': 'Asztali alkalmazás letöltése',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Csillagozz meg minket a GitHubon',
  'entry.githubStarAria': 'Csillagozd meg az Design App projektet a GitHubon',
  'entry.tabImageTemplates': 'Képsablonok',
  'entry.tabVideoTemplates': 'Videósablonok',
  'promptTemplates.searchPlaceholder': 'Sablonok keresése…',
  'promptTemplates.countLabel': '{n} találat',
  'promptTemplates.emptyImage': 'Még nincs telepített képsablon.',
  'promptTemplates.emptyVideo': 'Még nincs telepített videósablon.',
  'promptTemplates.emptyNoMatch': 'Egy sablon sem felel meg a keresésnek.',
  'promptTemplates.attributionFooter': 'Nyilvános prompt-tárakból átvéve. Minden kártya az eredeti szerzőre mutat.',
  'promptTemplates.openPreviewTitle': 'Prompt és előnézet megnyitása',
  'promptTemplates.sourcePrefix': 'Forrás:',
  'promptTemplates.fetchError': 'A sablon törzse nem tölthető be.',
  'promptTemplates.promptLabel': 'Prompt törzse',
  'promptTemplates.copyPrompt': 'Prompt másolása',
  'promptTemplates.copyDone': 'Másolva!',
  'promptTemplates.modelHint': 'Ajánlott modell: {model}',
  'promptTemplates.openSource': 'Eredeti megnyitása',
  'promptTemplates.openFullscreen': 'Teljes képernyős előnézet',
  'promptTemplates.closeFullscreen': 'Teljes képernyős előnézet bezárása',
  'promptTemplates.allSources': 'Minden forrás',
  'promptTemplates.sourceFilterAria': 'Szűrés forrás szerint',
  'promptTemplates.retry': 'Újra',

  'connectors.title': 'Kapcsolók',
  'connectors.subtitle': 'Helyi és jövőbeli adatforrások, amelyek élő artefaktokat táplálhatnak.',
  'connectors.account': 'Fiók',
  'connectors.noAccount': 'Nincs csatlakoztatva',
  'connectors.tools': 'Eszközök',
  'connectors.connect': 'Csatlakozás',
  'connectors.disconnect': 'Leválasztás',
  'connectors.authorizationPending': 'Várakozás az engedélyezésre...',
  'connectors.authorizationPendingHint': 'Fejezd be az engedélyezést a megnyitott ablakban.',
  'connectors.cancelAuthorization': 'Mégse',
  'connectors.configure': 'Beállítás',
  'connectors.unavailable': 'Nem érhető el',
  'connectors.phaseStubTitle': 'A kapcsoló API-k a 3. fázisban érkeznek; ez csak előnézet.',
  'connectors.statusAvailable': 'Elérhető',
  'connectors.statusConnected': 'Csatlakoztatva',
  'connectors.statusError': 'Hiba',
  'connectors.statusDisabled': 'Letiltva',
  'connectors.aboutLabel': 'Névjegy',
  'connectors.detailsLabel': 'Részletek',
  'connectors.statusLabel': 'Állapot',
  'connectors.category.aiAgents': 'AI-ügynökök',
  'connectors.category.aiInfrastructure': 'AI-infrastruktúra',
  'connectors.category.accounting': 'Könyvelés',
  'connectors.category.admin': 'Adminisztráció',
  'connectors.category.advertising': 'Hirdetés',
  'connectors.category.analytics': 'Analitika',
  'connectors.category.automation': 'Automatizálás',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Naptár',
  'connectors.category.commerce': 'Kereskedelem',
  'connectors.category.communication': 'Kommunikáció',
  'connectors.category.contacts': 'Kapcsolatok',
  'connectors.category.dataPlatform': 'Adatplatform',
  'connectors.category.database': 'Adatbázis',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Fejlesztői eszközök',
  'connectors.category.documentation': 'Dokumentáció',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Oktatás',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Események',
  'connectors.category.fieldService': 'Terepszolgálat',
  'connectors.category.finance': 'Pénzügy',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Űrlapok',
  'connectors.category.gaming': 'Játék',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Vendéglátás',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integráció',
  'connectors.category.localization': 'Lokalizáció',
  'connectors.category.logistics': 'Logisztika',
  'connectors.category.maps': 'Térképek',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Média',
  'connectors.category.meetings': 'Megbeszélések',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Megfigyelhetőség',
  'connectors.category.payments': 'Fizetések',
  'connectors.category.personal': 'Személyes',
  'connectors.category.presentations': 'Prezentációk',
  'connectors.category.procurement': 'Beszerzés',
  'connectors.category.product': 'Termék',
  'connectors.category.productivity': 'Produktivitás',
  'connectors.category.projectManagement': 'Projektmenedzsment',
  'connectors.category.recruiting': 'Toborzás',
  'connectors.category.research': 'Kutatás',
  'connectors.category.salesIntelligence': 'Értékesítési intelligencia',
  'connectors.category.scheduling': 'Ütemezés',
  'connectors.category.search': 'Keresés',
  'connectors.category.security': 'Biztonság',
  'connectors.category.signing': 'Aláírás',
  'connectors.category.social': 'Közösségi',
  'connectors.category.spreadsheets': 'Táblázatok',
  'connectors.category.storage': 'Tárhely',
  'connectors.category.support': 'Támogatás',
  'connectors.category.surveys': 'Kérdőívek',
  'connectors.category.tasks': 'Feladatok',
  'connectors.category.timeTracking': 'Időkövetés',
  'connectors.category.video': 'Videó',
  'connectors.category.whiteboard': 'Tábla',
  'connectors.categoryLabel': 'Kategória',
  'connectors.providerLabel': 'Szolgáltató',
  'connectors.toolsSection': 'Eszközök',
  'connectors.toolsLoading': 'Eszközök betöltése…',
  'connectors.noToolsAvailable': 'Még nincs elérhető eszköz. Csatlakozás után megjelennek ennek az integrációnak a képességei.',
  'connectors.toolDetailsUnavailable': 'Tool details are unavailable, but this connector reports {n} tools.',
  'connectors.loadMoreTools': 'Load more tools',
  'connectors.openDetailsAria': '{name} részleteinek megnyitása',
  'connectors.toolsBadgeNone': 'Nincs eszköz',
  'connectors.toolsBadgeOne': '{n} eszköz',
  'connectors.toolsBadgeMany': '{n} eszköz',
  'connectors.searchPlaceholder': 'Kapcsolók keresése…',
  'connectors.searchAriaLabel': 'Kapcsolók keresése név, szolgáltató vagy eszköz alapján',
  'connectors.searchClear': 'Keresés törlése',
  'connectors.emptyNoMatchTitle': 'Nincs „{query}” kifejezésre illeszkedő kapcsoló',
  'connectors.emptyNoMatchBody': 'Próbálj más kulcsszót, vagy töröld a keresést a teljes katalógushoz.',
  'connectors.emptyNoMatchAction': 'Keresés törlése',
  'connectors.credentialFormHint': 'Illessze be a(z) {name} hitelesítő adatait a csatlakozáshoz.',
  'connectors.credentialOptionalLabel': 'Opcionális',
  'connectors.credentialSubmit': 'Csatlakozás',
  'connectors.credentialCancel': 'Mégse',
  'connectors.credentialConnecting': 'Csatlakozás…',
  'connectors.credentialRequired': 'Töltse ki az összes kötelező mezőt.',

  'newproj.tabPrototype': 'Prototípus',
  'newproj.tabDeck': 'Diavetítés',
  'newproj.tabTemplate': 'Sablonból',
  'newproj.tabMedia': 'Média',
  'newproj.tabOther': 'Egyéb',
  'newproj.titlePrototype': 'Új prototípus',
  'newproj.titleDeck': 'Új diavetítés',
  'newproj.titleTemplate': 'Indulás sablonból',
  'newproj.titleImage': 'Új kép',
  'newproj.titleVideo': 'Új videó',
  'newproj.titleAudio': 'Új hang',
  'newproj.titleMedia': 'Új média',
  'newproj.titleOther': 'Új projekt',
  'newproj.namePlaceholder': 'Projekt neve',
  'newproj.fidelityLabel': 'Részletesség',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'Részletes',
  'newproj.toggleSpeakerNotes': 'Előadói jegyzetek használata',
  'newproj.toggleSpeakerNotesHint': 'Kevesebb szöveg a diákon — a beszédpontok a jegyzetekbe kerülnek.',
  'newproj.toggleAnimations': 'Animációk hozzáadása',
  'newproj.toggleAnimationsHint':
    'Mozgás (belépés, hover, átmenetek) hozzáadása a sablonra.',
  'newproj.templateLabel': 'Sablon',
  'newproj.noTemplatesTitle': 'Még nincs sablon',
  'newproj.noTemplatesBody':
    'Nyiss meg egy projektet, majd a fájlnézőben a Megosztás menüvel alakítsd sablonná. A sablonok itt jelennek meg.',
  'newproj.savedTemplate': 'Mentett sablon',
  'newproj.fileSingular': 'fájl',
  'newproj.filePlural': 'fájl',
  'newproj.create': 'Létrehozás',
  'newproj.createFromTemplate': 'Létrehozás sablonból',
  'newproj.createDisabledTitle':
    'Először ments el egy projektet sablonként (bármely projekt Megosztás menüjéből).',
  'newproj.importClaudeZip': 'Design ZIP importálása',
  'newproj.importClaudeZipTitle': 'Design .zip export importálása',
  'newproj.importingClaudeZip': 'Importálás…',
  'newproj.privacyFooter': 'Alapértelmezetten csak te láthatod a projekted.',
  'newproj.designSystem': 'Designrendszer',
  'newproj.dsNoneFreeform': 'Nincs — szabad formátum',
  'newproj.dsNoneSubtitleEmpty': 'Nincsenek rendszertokenek, válassz saját palettát',
  'newproj.dsNoneSubtitleSelected': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsCategoryFallback': 'Designrendszer',
  'newproj.dsSearch': 'Designrendszerek keresése…',
  'newproj.dsModeAria': 'Kijelölési mód',
  'newproj.dsModeSingle': 'Egy',
  'newproj.dsModeMulti': 'Több',
  'newproj.dsNoneTitle': 'Nincs — szabad formátum',
  'newproj.dsNoneSub': 'Hagyd ki a rendszertokeneket. Az ügynök maga választ palettát.',
  'newproj.dsEmpty': 'Egy designrendszer sem felel meg a „{query}" keresésnek.',
  'newproj.dsFootSingular': 'csak inspiráció.',
  'newproj.dsFootPlural': 'csak inspiráció.',
  'newproj.dsFootClear': 'Törlés',
  'newproj.dsBadgeDefault': 'ALAPÉRT.',
  'newproj.dsPrimaryFallback': 'Elsődleges',
  'newproj.surfaceImage': 'Kép',
  'newproj.surfaceVideo': 'Videó',
  'newproj.surfaceAudio': 'Hang',
  'newproj.modelLabel': 'Modell',
  'newproj.modelSearch': 'Modellek keresése…',
  'newproj.modelEmpty': 'Nincs találat a modellekre.',
  'newproj.modelRecommended': 'Ajánlott',
  'newproj.modelMissingTitle': 'Modell kiválasztása',
  'newproj.modelMissingSub': 'Válassz modellt ehhez a felülethez.',
  'newproj.aspectLabel': 'Képarány',
  'newproj.videoLengthLabel': 'Hossz',
  'newproj.videoLengthSeconds': '{n} mp',
  'newproj.audioKindLabel': 'Hangtípus',
  'newproj.audioKindMusic': 'Zene',
  'newproj.audioKindSpeech': 'Beszéd / TTS',
  'newproj.audioKindSfx': 'Hangeffekt',
  'newproj.audioDurationLabel': 'Időtartam',
  'newproj.audioDurationSeconds': '{n} mp',
  'newproj.voiceLabel': 'Hang',
  'newproj.voicePlaceholder': 'Szolgáltatói hang-id, opcionális',
  'newproj.connectorsLabel': 'Kapcsolók',
  'newproj.connectorsHint': 'Adatforrások, amelyeket ez az artefaktum használhat.',
  'newproj.connectorsEmptyTitle': 'Nincs beállított kapcsoló',
  'newproj.connectorsEmptyBody': 'Csatlakoztass egy adatforrást, hogy az élő artefaktum valódi adatokat használjon helykitöltők helyett.',
  'newproj.connectorsEmptyCta': 'Kapcsolók beállítása →',
  'newproj.connectorsLoading': 'Kapcsolók betöltése…',
  'newproj.connectorsCountOne': '{n} csatlakoztatva',
  'newproj.connectorsCountMany': '{n} csatlakoztatva',
  'newproj.connectorsManage': 'Kezelés',
  'newproj.promptTemplateLabel': 'Hivatkozási sablon',
  'newproj.promptTemplateNoneTitle': 'Nincs — saját megfogalmazás',
  'newproj.promptTemplateNoneSub': 'Hagyd ki a galériát, írd le a saját brieffed',
  'newproj.promptTemplateRefSub': 'Hivatkozási sablon',
  'newproj.promptTemplateSearch': 'Sablonok keresése…',
  'newproj.promptTemplateEmpty': 'Még nincs telepített sablon ehhez a felülethez.',
  'newproj.promptTemplateBodyLabel': 'Prompt (módosítható)',
  'newproj.promptTemplateOptimizeHint':
    'Bármit módosíthatsz — a változtatásaid beépülnek az ügynök briefjébe.',
  'newproj.promptTemplateBodyEmpty':
    'Üres törzs — az ügynök nem kap sablonhivatkozást.',
  'newproj.deleteTemplateTitle': 'Sablon törlése',
  'newproj.deleteTemplateConfirm': 'Törlöd a(z) „{name}" sablont? Ez nem vonható vissza.',
  'newproj.deleteTemplateConfirmCta': 'Sablon törlése',
  'newproj.deleteTemplateError':
    'A sablon törlése nem sikerült. Próbáld újra.',

  'designs.subRecent': 'Legutóbbi',
  'designs.subYours': 'A te terveid',
  'designs.filterAria': 'Projektek szűrése',
  'designs.searchPlaceholder': 'Keresés…',
  'designs.emptyNoProjects': 'Még nincs projekt.',
  'designs.emptyNoMatch': 'Egy projekt sem felel meg a keresésnek.',
  'designs.deleteTitle': 'Projekt törlése',
  'designs.deleteConfirm': 'Törlöd a(z) „{name}" projektet?',
  'designs.cardFreeform': 'szabad formátum',
  'designs.status.notStarted': 'Nem kezdődött el',
  'designs.status.queued': 'Sorban',
  'designs.status.running': 'Fut',
  'designs.status.awaitingInput': 'Bevitelre vár',
  'designs.status.succeeded': 'Befejezve',
  'designs.status.published': 'Közzétéve',
  'designs.status.failed': 'Sikertelen',
  'designs.status.canceled': 'Megszakítva',
  'designs.viewToggleAria': 'Nézet módja',
  'designs.viewGrid': 'Rácsnézet',
  'designs.viewKanban': 'Tábla nézet',
  'designs.kanbanEmptyColumn': 'Nincs terv',
  'designs.deleteAria': '{name} projekt törlése',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',

  'examples.typeLabel': 'Típus',
  'examples.surfaceLabel': 'Felület',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Kép',
  'examples.surfaceVideo': 'Videó',
  'examples.surfaceAudio': 'Hang',
  'examples.scenarioLabel': 'Forgatókönyv',
  'examples.modeAll': 'Mind',
  'examples.modePrototypeDesktop': 'Prototípusok · Asztali',
  'examples.modePrototypeMobile': 'Prototípusok · Mobil',
  'examples.modeDeck': 'Diák',
  'examples.modeDocument': 'Dokumentumok és sablonok',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Élő',
  'examples.scenarioGeneral': 'Általános',
  'examples.scenarioEngineering': 'Mérnöki',
  'examples.scenarioProduct': 'Termék',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Értékesítés',
  'examples.scenarioFinance': 'Pénzügy',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operáció',
  'examples.scenarioSupport': 'Ügyfélszolgálat',
  'examples.scenarioLegal': 'Jogi',
  'examples.scenarioEducation': 'Oktatás',
  'examples.scenarioPersonal': 'Személyes',
  'examples.emptyNoSkills': 'Nincs elérhető skill. Fut a daemon?',
  'examples.searchPlaceholder': 'Példák keresése…',
  'examples.searchAria': 'Példák keresése név alapján',
  'examples.emptyNoMatch': 'Egy példa sem felel meg ezeknek a szűrőknek.',
  'examples.openPreview': '⤢ Előnézet megnyitása',
  'examples.loadingPreview': 'Előnézet betöltése…',
  'examples.hoverPreview': 'Vidd fölé az egeret az előnézethez',
  'examples.usePrompt': 'Használd ezt a promptot',
  'examples.previewModalTitle': 'Teljes előnézet (modális)',
  'examples.shareTitle': 'Példa megosztása',
  'examples.shareLoadFirst': 'Vidd fölé az egeret az előnézet betöltéséhez',
  'examples.unavailablePlaceholder': 'Nincs mellékelt {kind} előnézet — nyisd meg a részletekért',
  'examples.shareUnavailable': 'Nincs megosztható {kind} előnézet mellékelve',
  'examples.shareMenu': 'Megosztás ▾',
  'examples.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'examples.exportPptxLocked': 'Exportálás PPTX-ként… (előbb sablont nyiss)',
  'examples.tagSlideDeck': 'Diavetítés',
  'examples.tagTemplate': 'Sablon',
  'examples.tagDesignSystem': 'Designrendszer',
  'examples.tagMobilePrototype': 'Mobil prototípus',
  'examples.tagDesktopPrototype': 'Asztali prototípus',
  'examples.tagImage': 'Kép',
  'examples.tagVideo': 'Videó',
  'examples.tagAudio': 'Hang',
  'examples.previewLabel': 'Előnézet',

  'ds.surfaceLabel': 'Felület',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Kép',
  'ds.surfaceVideo': 'Videó',
  'ds.surfaceAudio': 'Hang',
  'ds.searchPlaceholder': 'Designrendszerek keresése…',
  'ds.emptyNoMatch': 'Egy designrendszer sem felel meg a keresésnek.',
  'ds.badgeDefault': 'ALAPÉRT.',
  'ds.preview': 'Előnézet',
  'ds.previewTitle': 'Designrendszer előnézete',
  'ds.categoryAll': 'Mind',
  'ds.categoryUncategorized': 'Kategorizálatlan',
  'ds.showcase': 'Bemutató',
  'ds.tokens': 'Tokenek',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md betöltése…',

  'avatar.title': 'Fiók és beállítások',
  'avatar.localCli': 'Helyi CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Helyi CLI használata',
  'avatar.useApi': 'API · BYOK használata',
  'avatar.codeAgent': 'Kód-ügynök',
  'avatar.rescan': 'PATH újraellenőrzése',
  'avatar.settings': 'Beállítások',
  'avatar.backToProjects': 'Vissza a projektekhez',
  'avatar.metaActive': 'aktív',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'kiválasztva',
  'avatar.noAgentSelected': 'nincs kiválasztott ügynök',
  'avatar.modelSection': 'Modell',
  'avatar.modelLabel': 'Modell',
  'avatar.reasoningLabel': 'Gondolkodás',
  'avatar.customSuffix': '(egyedi)',

  'inlineSwitcher.chipTitle': 'CLI / modell váltása',
  'inlineSwitcher.chipCli': 'Helyi CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'alapértelmezett',
  'inlineSwitcher.noAgent': 'nincs ügynök',
  'inlineSwitcher.modeLabel': 'Mód',
  'inlineSwitcher.agentLabel': 'Ügynök',
  'inlineSwitcher.providerLabel': 'Szolgáltató',
  'inlineSwitcher.modelLabel': 'Modell',
  'inlineSwitcher.useCli': 'Helyi CLI használata',
  'inlineSwitcher.useByok': 'Saját API-kulcs használata',
  'inlineSwitcher.daemonOffline': 'A démon offline — nyisd meg a beállításokat',
  'inlineSwitcher.noAgentsDetected': 'Nincs CLI a PATH-ban',
  'inlineSwitcher.openSettingsForModel': 'Állítsd be a szolgáltatót a Beállításokban',
  'inlineSwitcher.missingApiKey': 'Hiányzó API-kulcs — add hozzá a Beállításokban.',
  'inlineSwitcher.openFullSettings': 'Végrehajtási beállítások megnyitása',
  'inlineSwitcher.customSuffix': '(egyedi)',

  'project.backToProjects': 'Vissza a projektekhez',
  'project.metaFreeform': 'szabad formátum',
  'project.resizeChatPanel': 'Csevegőpanel átméretezése',
  'project.instructionsActive': 'Aktív – minden üzenethez hozzáadva',
  'chat.tabChat': 'Csevegés',
  'chat.tabComments': 'Megjegyzések',
  'chat.commentsSoon': 'Megjegyzések — hamarosan',
  'chat.comments.attached': 'Attached to chat',
  'chat.comments.emptyAttached': 'No comments attached.',
  'chat.comments.saved': 'Saved comments',
  'chat.comments.emptySaved': 'No saved comments.',
  'chat.comments.add': 'Add',
  'chat.comments.addAll': 'Add all',
  'chat.comments.remove': 'Remove',
  'chat.comments.placeholder': 'Comment on this element…',
  'chat.comments.addSend': 'Add & send',
  'chat.comments.updateSend': 'Update & send',
  'chat.comments.removeAttachment': 'Remove comment attachment',
  'chat.comments.removeAttachmentAria': 'Remove comment attachment for {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.comments.targetImage': 'Image',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Add a note for this annotation',
  'chat.annotationQueue': 'Queue',
  'chat.annotationQueueing': 'Queueing...',
  'chat.annotationSending': 'Sending...',
  'chat.annotationSendDisabledReason': 'A task is currently running',
  'chat.annotationPreviewMissing': 'Could not capture the preview. Please try again.',
  'chat.annotationPreviewMissingInk': 'Could not capture the preview. Try again to avoid sending only ink.',
  'chat.annotationTimeout': 'Annotation send timed out. Please try again.',
  'chat.annotationFailed': 'Annotation send failed. Please try again.',
  'chat.annotationProjectCreateFailed': 'Could not create a project, so the annotation was not sent.',
  'chat.annotationUploadFailed': 'Attachment upload failed. Please try again.',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.conversationsTitle': 'Beszélgetések',
  'chat.conversationsAria': 'Beszélgetések előzménye',
  'chat.newConversation': 'Új beszélgetés',
  'chat.newConversationsTitle': 'Új beszélgetés',
  'chat.conversationsHeading': 'Beszélgetések',
  'chat.new': 'Új',
  'chat.emptyConversations': 'Még nincs beszélgetés.',
  'chat.deleteConversation': 'Beszélgetés törlése',
  'chat.renameConversationLabel': '„{title}” átnevezése',
  'chat.deleteConversationConfirm':
    'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',
  'chat.untitledConversation': 'Cím nélküli beszélgetés',
  'chat.startTitle': 'Indíts beszélgetést',
  'chat.startHint': "Írd le, mit szeretnél létrehozni, vagy indulj ki az egyik példából:",
  'chat.fillInputTitle': 'Kattints a beviteli mező kitöltéséhez',
  'chat.jumpToLatest': 'Ugrás a legutóbbira',
  'chat.scrollToLatest': 'Görgetés a legutóbbira',
  'chat.you': 'Te',
  'chat.openFile': '{name} megnyitása',
  'chat.copyPrompt': 'Prompt másolása',
  'chat.copyDone': 'Másolva!',
  'chat.composerPlaceholder': "Írd le, mit szeretnél létrehozni…",
  'chat.composerHint': "⌘/Ctrl + Enter küldéshez · add meg a célt, tartalmat, stílust és formátumot",
  'chat.cliSettingsTitle': 'CLI- és modellbeállítások',
  'chat.cliSettingsAria': 'CLI- és modellbeállítások megnyitása',
  'chat.attachTitle': 'Fájlok csatolása (vagy beillesztés / húzás)',
  'chat.attachAria': 'Fájlok csatolása',
  'chat.importTitle': 'Források importálása (hamarosan)',
  'chat.importLabel': 'Importálás',
  'chat.importComingSoon': 'Hamarosan',
  'chat.importSoon': 'Hamarosan',
  'chat.importFig': '.fig fájl feltöltése',
  'chat.importGitHub': 'GitHub csatlakoztatása',
  'chat.importWeb': 'Webelem mentése',
  'chat.importFolder': 'Kódmappa hozzákapcsolása',
  'chat.importSkills': 'Skillek és designrendszerek',
  'chat.importProject': 'Reference another project',
  'chat.linkedFolderRemoveAria': 'Hozzákapcsolt mappa eltávolítása {path}',
  'chat.linkedFolderNotFound': 'A mappa nem létezik',
  'chat.linkedFolderAlready': 'Ez a mappa már hozzá van kapcsolva',
  'chat.linkedFolderPickError': 'Nem sikerült megnyitni a mappaválasztót',
  'chat.queuedHeader': 'Queued',
  'chat.queuedToSend': 'to Send',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedEdit': 'Edit',
  'chat.queuedMore': 'more queued',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Küldés',
  'chat.stop': 'Leállítás',
  'chat.removeAria': '{name} eltávolítása',
  'chat.example1Title': 'Magazinszerű pitch deck',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt':
    'Egy 10 diás magazinszerű pitch deck egy designstúdió seed köréhez — svájci rácselrendezés, túlméretezett serif címsorok félkövér drop capekkel, monospace szakaszszámok, bőséges üres tér, és teljes kihasználású fotódiák szövegközpontú diákkal váltakozva. Borító, vízió, piac, termék, eredmények, csapat, kérés, kapcsolat.',
  'chat.example2Title': 'SaaS analitikai dashboard',
  'chat.example2Tag': 'Adat',
  'chat.example2Prompt':
    'Sűrű analitikai dashboard fejlesztői SaaS-hez — KPI-csík hét/hét deltákkal, két egymásra rakott vonaldiagram (MRR és aktív munkaterületek), világtérképes hőtérkép a használatról, kohorsz-megtartási rács, top-ügyfelek ranglista, és valós idejű eseménystream. Sötét téma, táblázatos monospace számok, sparkline akcentusok.',
  'chat.example3Title': 'Éves jelentés long-scroll',
  'chat.example3Tag': 'Magazinszerű',
  'chat.example3Prompt':
    'Interaktív éves jelentés egy klíma-non-profitnak — long-scroll magazinszerű elrendezés, nagy kiemelt-idézet blokkokkal, adatvizualizációkkal (egymásra rakott oszlopok, animált számlálók, projekthelyek choropleth térképe), fotó-megszakítókkal, donor fallal, és záró cselekvésre hívással. Modern serif törzs, sans-serif diagramcímkék, földes papírpaletta.',

  'preview.shareMenu': 'Megosztás',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy template link',
  'preview.copyShareText': 'Copy share text',
  'preview.shareSocialGroup': 'Share to social',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export files',
  'preview.shareCopied': 'Copied',
  'preview.shareCopyFailed': 'Copy failed',
  'preview.shareTextDefault': 'Design App template: {title}',
  'preview.openInNewTab': 'Megnyitás új lapon',
  'preview.exit': '⤓ Kilépés',
  'preview.fullscreen': '⤢ Teljes képernyő',
  'preview.closeTitle': 'Bezárás (Esc)',
  'preview.loading': '{label} betöltése…',
  'preview.errorTitle': 'A példa betöltése nem sikerült.',
  'preview.errorBody': 'A példa HTML-jének letöltése meghiúsult. Győződj meg róla, hogy az Design App fut, majd próbáld újra.',
  'preview.retry': 'Újra',
  'preview.unavailableTitle': 'Ehhez a skillhez nincs mellékelt előnézet.',
  'preview.unavailableBody': 'Ez a skill {kind} kimenetet készít — futtasd a promptot a csevegésben egy létrehozásához.',
  'preview.showSidebar': '{label} megjelenítése',
  'preview.hideSidebar': '{label} elrejtése',

  'misc.savedTemplate': 'Mentett sablon',
  'misc.primary': 'Elsődleges',
  'misc.designSystem': 'Designrendszer',

  'workspace.designFiles': 'Designfájlok',
  'workspace.focusMode': 'Focus workspace',
  'workspace.showChat': 'Show chat',
  'workspace.closeTab': 'Lap bezárása',
  'workspace.deleteFileConfirm': 'Törlöd a(z) „{name}" fájlt a projektmappából?',
  'workspace.deleteSelectedFilesConfirm': 'Törlöd a(z) {n} kijelölt fájlt a projektmappából?',
  'workspace.deleteSelectedFilesPartial': '{n} fájl törlése sikertelen.',
  'workspace.openFromDesignFiles': 'Nyiss meg egy fájlt innen:',
  'workspace.designFilesLink': 'Designfájlok',
  'workspace.loadingSketch': 'Vázlat betöltése…',
  'designFiles.title': 'Designfájlok',
  'designFiles.upload': 'Fájlok feltöltése',
  'designFiles.pasteText': 'Beillesztés szövegfájlként',
  'designFiles.newSketch': 'Új vázlat',
  'designFiles.empty': 'A kreációk itt jelennek meg',
  'designFiles.refresh': 'Frissítés',
  'designFiles.delete': 'Törlés',
  'designFiles.searchPlaceholder': 'Fájlok keresése…',
  'designFiles.up': 'Fel',
  'designFiles.back': 'Vissza',
  'designFiles.crumbs': 'projekt',
  'designFiles.rowMenu': 'Sor menü',
  'designFiles.openInTab': 'Megnyitás lapon',
  'designFiles.download': 'Letöltés',
  'designFiles.downloadSelected': '{n} fájl letöltése ZIP-ként',
  'designFiles.clearSelection': 'Kijelölés törlése',
  'designFiles.selectPage': 'Összes kijelölése az oldalon',
  'designFiles.selectAll': 'Összes kijelölése',
  'designFiles.deleteSelected': '{n} törlése',
  'designFiles.dropTitle': '⤓ Húzd ide a fájlokat',
  'designFiles.dropDesc':
    'Képek, dokumentumok, hivatkozások vagy mappák — az ügynök kontextusként használja őket.',
  'designFiles.upload.title': 'Fájlok feltöltése',
  'designFiles.paste.title': 'Szöveg beillesztése fájlként',
  'designFiles.upload.label': 'Feltöltés',
  'designFiles.paste.label': 'Beillesztés',
  'designFiles.previewOpen': 'Megnyitás',
  'designFiles.previewClose': 'Előnézet bezárása',
  'designFiles.modified': 'Módosítva: {time} · {size}',
  'designFiles.weeksAgo': '{n} hete',
  'designFiles.groupBy': 'Csoportosítás',
  'designFiles.groupByKind': 'Típus',
  'designFiles.groupByModified': 'Módosítás',
  'designFiles.expandGroup': 'Kibontás',
  'designFiles.collapseGroup': 'Összecsukás',
  'designFiles.sectionPages': 'Oldalak',
  'designFiles.sectionScripts': 'Szkriptek',
  'designFiles.sectionImages': 'Képek',
  'designFiles.sectionSketches': 'Vázlatok',
  'designFiles.sectionOther': 'Egyéb',
  'designFiles.modifiedToday': 'Ma',
  'designFiles.modifiedYesterday': 'Tegnap',
  'designFiles.modifiedPrevious7Days': 'Előző 7 nap',
  'designFiles.modifiedPrevious30Days': 'Előző 30 nap',
  'designFiles.modifiedOlder': 'Régebbi',
  'designFiles.showMore': '+{n} további megjelenítése',
  'designFiles.kindHtml': 'HTML oldal',
  'designFiles.kindImage': 'Kép',
  'designFiles.kindSketch': 'Vázlat',
  'designFiles.kindText': 'Szöveg',
  'designFiles.kindCode': 'Szkript',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokumentum',
  'designFiles.kindPresentation': 'Prezentáció',
  'designFiles.kindSpreadsheet': 'Táblázat',
  'designFiles.kindBinary': 'Bináris',
  'designFiles.kindFolder': 'Mappa',
  'designFiles.folderCount': '{n} fájl',
  'designFiles.colName': 'Név',
  'designFiles.colKind': 'Típus',
  'designFiles.colModified': 'Módosítva',
  'designFiles.perPage': 'Mutat',
  'designFiles.all': 'Összes',
  'designFiles.prev': 'Előző',
  'designFiles.next': 'Következő',
  'designFiles.jumpToPage': 'Ugrás oldalra',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'quickSwitcher.placeholder': 'Fájl megnyitása…',
  'quickSwitcher.empty': 'Nincsenek fájlok ebben a projektben',
  'quickSwitcher.noMatches': 'Nincs találat',
  'quickSwitcher.navigate': 'navigáció',
  'quickSwitcher.open': 'megnyitás',
  'quickSwitcher.close': 'bezárás',
  'pasteDialog.title': 'Szöveg beillesztése',
  'pasteDialog.hint': 'A projektmappába mentve. Bármilyen név adható.',
  'pasteDialog.fileNameLabel': 'Fájlnév',
  'pasteDialog.namePlaceholder': 'jegyzetek.txt',
  'pasteDialog.contentLabel': 'Tartalom',
  'pasteDialog.contentPlaceholder': 'Illessz be bármit…',
  'pasteDialog.save': 'Mentés',
  'pasteDialog.cancel': 'Mégse',
  'sketch.save': 'Vázlat mentése',
  'sketch.cancel': 'Mégse',
  'sketch.saving': 'Mentés…',
  'sketch.saved': 'Mentve',
  'sketch.tooltipDirty': 'Mentetlen változtatások',
  'sketch.tooltipClean': 'Mentve',
  'fileViewer.empty': 'Válassz fájlt a megtekintéshez.',
  'fileViewer.loading': 'Betöltés…',
  'fileViewer.exportPptx': 'Exportálás PPTX-ként',
  'fileViewer.openInNewTab': 'Megnyitás új lapon',
  'fileViewer.copyPath': 'Útvonal másolása',
  'fileViewer.copied': 'Másolva!',
  'fileViewer.share': 'Megosztás',
  'fileViewer.binaryMeta': 'Bináris · {size}',
  'fileViewer.binaryNote':
    'Bináris fájl ({size} bájt). A megtekintéshez töltsd le, vagy nyisd meg lemezről.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokumentum',
  'fileViewer.presentationMeta': 'Prezentáció',
  'fileViewer.spreadsheetMeta': 'Táblázat',
  'fileViewer.previewUnavailable': 'Előnézet nem elérhető. Töltsd le vagy nyisd meg a fájlt a megtekintéshez.',
  'fileViewer.download': 'Letöltés',
  'fileViewer.open': 'Megnyitás',
  'fileViewer.imageMeta': 'Kép · {size}',
  'fileViewer.reactMeta': 'React komponens · {size}',
  'fileViewer.sketchMeta': 'Vázlat · {size}',
  'fileViewer.markdownStreamingMeta': 'Streamelő előnézet…',
  'fileViewer.markdownErrorMeta': 'Az előnézet hiányos lehet (generálási hiba).',
  'fileViewer.markdownStreamingStatus': 'Streamelés… részleges markdownt mutatva.',
  'fileViewer.markdownErrorStatus': 'Generálási hiba. Az utolsó elérhető tartalom látszik.',
  'fileViewer.videoMeta': 'Videó · {size}',
  'fileViewer.audioMeta': 'Hang · {size}',
  'fileViewer.reload': 'Újratöltés',
  'fileViewer.reloadDisk': 'Újratöltés lemezről',
  'fileViewer.copy': 'Másolás',
  'fileViewer.copyTitle': 'Fájltartalom másolása',
  'fileViewer.saveDisabled': 'Mentés (csak olvasható nézet)',
  'fileViewer.save': 'Mentés',
  'fileViewer.preview': 'Előnézet',
  'fileViewer.source': 'Forrás',
  'fileViewer.tweaks': 'Finomhangolás',
  'fileViewer.tweaksUnavailable': 'Nincs finomhangolási panel ebben az artefaktumban',
  'fileViewer.jsxModuleTitle': 'Nincs önálló előnézet',
  'fileViewer.jsxModuleBody': 'Ez a fájl egy komponensmodul, amelyet egy másik oldal tölt be.',
  'fileViewer.jsxModuleCta': 'Nyisd meg az oldalt, amely megjeleníti:',
  'fileViewer.comment': 'Megjegyzés',
  'fileViewer.edit': 'Szerkesztés',
  'fileViewer.draw': 'Rajz',
  'manualEdit.layers': "Layers",
  'manualEdit.editableCount': "{count} editable",
  'manualEdit.hiddenBadge': "Hidden",
  'manualEdit.title': "Manual editor",
  'manualEdit.fallbackTitle': 'Edit',
  'manualEdit.movePanel': 'Move edit panel',
  'manualEdit.closePanel': 'Close edit panel',
  'manualEdit.selectLayer': "Select a layer",
  'manualEdit.empty': "Click an element in the preview or choose a layer.",
  'manualEdit.noEditableLayers': "No editable layers found.",
  'manualEdit.noClass': "no class",
  'manualEdit.tabsAria': "Manual edit tabs",
  'manualEdit.tabContent': "Content",
  'manualEdit.tabStyle': "Style",
  'manualEdit.tabAttributes': "Attributes",
  'manualEdit.tabHtml': "Html",
  'manualEdit.tabSource': "Source",
  'manualEdit.attributesJson': "Attributes JSON",
  'manualEdit.selectedHtml': "Selected element HTML",
  'manualEdit.fullSource': "Full artifact source",
  'manualEdit.applyContent': "Apply Content",
  'manualEdit.applyStyle': "Apply Style",
  'manualEdit.applyAttributes': "Apply Attributes",
  'manualEdit.applyHtml': "Apply HTML",
  'manualEdit.applySource': "Apply Source",
  'manualEdit.invalidAttributes': "Invalid attributes JSON.",
  'manualEdit.changes': "Changes",
  'manualEdit.undo': "Undo",
  'manualEdit.redo': "Redo",
  'manualEdit.noChanges': "No manual edits yet.",
  'manualEdit.imageUrl': "Image URL",
  'manualEdit.altText': "Alt text",
  'manualEdit.label': "Label",
  'manualEdit.text': "Text",
  'manualEdit.href': "Href",
  'manualEdit.textColor': "Text color",
  'manualEdit.background': "Background",
  'manualEdit.fontSize': "Font size",
  'manualEdit.weight': "Weight",
  'manualEdit.align': "Align",
  'manualEdit.padding': "Padding",
  'manualEdit.margin': "Margin",
  'manualEdit.radius': "Radius",
  'manualEdit.border': "Border",
  'manualEdit.width': "Width",
  'manualEdit.minHeight': "Min height",
  'fileViewer.zoomOut': 'Kicsinyítés',
  'fileViewer.zoomIn': 'Nagyítás',
  'fileViewer.resetZoom': 'Nagyítás visszaállítása',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Újratöltés',
  'fileViewer.previousSlide': 'Előző dia',
  'fileViewer.nextSlide': 'Következő dia',
  'fileViewer.slideNavAria': 'Dianavigáció',
  'fileViewer.present': 'Bemutatás',
  'fileViewer.presentInTab': 'Ezen a lapon',
  'fileViewer.presentFullscreen': 'Teljes képernyő',
  'fileViewer.presentNewTab': 'Új lap',
  'fileViewer.exitPresentation': 'Bemutató bezárása',
  'fileViewer.shareLabel': "Megosztás",
  'fileViewer.shareMenuShareLink': 'SHARE LINK',
  'fileViewer.shareMenuPublishOnline': 'PUBLISH ONLINE',
  'fileViewer.shareMenuDownload': 'DOWNLOAD',
  'fileViewer.shareMenuPresentation': 'Presentation',
  'fileViewer.shareMenuSourceFiles': 'Source files',
  'fileViewer.shareMenuSave': 'SAVE',
  'fileViewer.copyProviderLink': 'Copy {provider} link',
  'fileViewer.copyCloudflareLink': 'Copy Cloudflare link',
  'fileViewer.screenshotCopying': 'Copying screenshot...',
  'fileViewer.screenshotCopied': 'Screenshot copied to clipboard',
  'fileViewer.screenshotClipboardDenied': 'Browser blocked clipboard access',
  'fileViewer.screenshotPreviewLoading': 'Preview is still loading. Try again in a moment.',
  'fileViewer.screenshotCaptureFailed': 'Could not capture the preview. Please try again.',
  'fileViewer.exportPdf': 'Exportálás PDF-ként',
  'fileViewer.exportPdfAllSlides': 'Exportálás PDF-ként (minden dia)',
  'fileViewer.exportPptxBusy': 'Várj, amíg az aktuális kör befejeződik.',
  'fileViewer.exportPptxHint':
    'Küldj kérést az ügynöknek, hogy alakítsa át ezt a designt PPTX-szé.',
  'fileViewer.exportPptxNa': 'A PPTX export itt nem elérhető.',
  'fileViewer.exportZip': 'Letöltés .zip-ként',
  'fileViewer.exportHtml': 'Exportálás önálló HTML-ként',
  'fileViewer.exportMd': 'Exportálás Markdown-ként',
  'fileViewer.exportImage': 'Exportálás képként',
  'fileViewer.exportImageFailed': 'A képrögzítés sikertelen. Kérjük, próbálja újra, vagy használja a böngészője képernyőkép eszközét.',
  'fileViewer.exportJsx': 'Exportálás JSX-ként',
  'fileViewer.exportReactHtml': 'Előnézet exportálása HTML-ként',
  'fileViewer.exportStarted': 'Export started',
  'fileViewer.saveAsTemplate': 'Mentés sablonként…',
  'fileViewer.savingTemplate': 'Sablon mentése…',
  'fileViewer.savedTemplate': 'Mentve „{name}" néven',
  'fileViewer.savedTemplateFail': 'A sablon mentése nem sikerült — próbáld újra.',
  'fileViewer.templateNamePrompt': 'Sablon neve',
  'fileViewer.templateNameDefault': 'Cím nélküli sablon',
  'fileViewer.templateDescPrompt':
    'Rövid leírás (opcionális — mitől hasznos ez a sablon?)',
  'fileViewer.deployToVercel': 'Telepítés Vercelre',
  'fileViewer.redeployToVercel': 'Újratelepítés',
  'fileViewer.deployingToVercel': 'Telepítés Vercelre…',
  'fileViewer.deployProviderLabel': 'Szolgáltató',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Telepítés ide: {provider}',
  'fileViewer.redeployToProvider': 'Újratelepítés ide: {provider}',
  'fileViewer.deployingToProvider': 'Telepítés ide: {provider}…',
  'fileViewer.preparingPublicLink': 'Nyilvános link előkészítése…',
  'fileViewer.copyDeployLink': 'Link másolása',
    'fileViewer.deployModalTitle': 'Telepítés',
  'fileViewer.deployModalSubtitle': 'A kiválasztott szolgáltató fiókjával telepítheted ezt a HTML-előnézetet.',
  'fileViewer.vercelToken': 'Vercel token',
  'fileViewer.vercelTokenGetLink': 'Vercel token kérése',
  'fileViewer.vercelTokenPlaceholder': 'Illeszd be a Vercel tokenedet',
  'fileViewer.vercelTokenReuseHint': 'A mentett tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.vercelTokenRequired': 'Előbb adj meg és ments el egy Vercel tokent.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API token',
  'fileViewer.cloudflareApiTokenGetLink': 'Cloudflare API token kérése',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Illeszd be a Cloudflare API tokenedet',
  'fileViewer.cloudflareApiTokenReuseHint': 'A mentett Cloudflare API tokent használjuk. Adj meg újat a cseréhez.',
  'fileViewer.cloudflareApiTokenRequired': 'Előbb adj meg és ments el egy Cloudflare API tokent.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pages Edit is required for deploys. Zone Read is required to list domains. DNS Edit is only needed when binding a custom domain.',
  'fileViewer.vercelTeamId': 'Team ID',
  'fileViewer.vercelTeamSlug': 'Team slug',
  'fileViewer.cloudflareAccountId': 'Fiók ID',
  'fileViewer.cloudflareAccountIdHint': 'Kötelező. A fiók ID-t a Cloudflare irányítópulton találod.',
  'fileViewer.cloudflareAccountIdRequired': 'Előbb add meg és mentsd el a Cloudflare Account ID-t.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: choose a Cloudflare domain and prefix to bind a custom subdomain. pages.dev will still be available.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Opcionális',
  'fileViewer.vercelPreviewOnly': 'A telepítések egyelőre csak Preview-k.',
  'fileViewer.cloudflarePagesPreviewHint': 'A Cloudflare Pages Direct Uploadot használ.',
  'fileViewer.savingConfig': 'Mentés…',
  'fileViewer.deployConfigSaveFailed': 'A Vercel beállítások nem menthetők.',
  'fileViewer.deployFailed': 'A telepítés sikertelen. Ellenőrizd a Vercel beállításokat, és próbáld újra.',
  'fileViewer.deployProviderConfigSaveFailed': 'A {provider} beállításai nem menthetők.',
  'fileViewer.deployProviderFailed': 'A {provider} telepítés sikertelen. Ellenőrizd a beállításokat, és próbáld újra.',
  'fileViewer.deployResultLabel': 'Telepített URL',
  'fileViewer.deployLinkReady': 'Kész',
  'fileViewer.deploySuccessToast': 'A telepítés sikeresen feltöltve',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Nyilvános link várólistán',
  'fileViewer.deployLinkDelayed': 'A webhely telepítve van. A szolgáltató még készíti a nyilvános linket.',
  'fileViewer.deployLinkFailed': 'Az egyéni domain sikertelen',
  'fileViewer.deployLinkProtectedLabel': 'Telepítési védelem bekapcsolva',
  'fileViewer.deployLinkProtected': 'A webhely telepítve van, de ez az előnézeti link hitelesítést kér. Kapcsold ki a Deployment Protectiont, vagy használj saját domaint.',
  'fileViewer.retryLink': 'Újra most',

  'questionForm.submit': 'Beküldés',
  'questionForm.skip': 'Kihagyás',
  'questionForm.locked': 'Megválaszolva',

  'conv.switch': 'Beszélgetés váltása',
  'conv.label': 'Beszélgetés',
  'conv.heading': 'Beszélgetések',
  'conv.new': '+ Új',
  'conv.empty': 'Még nincs beszélgetés.',
  'conv.untitled': 'Cím nélküli beszélgetés',
  'conv.renameTooltip': 'Dupla kattintás az átnevezéshez',
  'conv.delete': 'Beszélgetés törlése',
  'conv.deleteConfirm': 'Törlöd a(z) „{title}" beszélgetést? Ez eltávolítja az üzeneteit.',

  'agentPicker.label': 'Ügynök',
  'agentPicker.modeChoose': 'Válassz végrehajtási módot',
  'agentPicker.localCli': 'Helyi CLI',
  'agentPicker.daemonOff': 'a daemon kikapcsolva',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Válassz egy észlelt code-agent CLI-t',
  'agentPicker.noAgents': 'nincs ügynök a PATH-on',
  'agentPicker.notInstalled': 'nincs telepítve',
  'agentPicker.rescan': 'Helyi PATH újraellenőrzése ügynökökért',

  'tool.openInTab': '{name} megnyitása lapon',
  'tool.open': 'megnyitás',
  'tool.todos': 'Feladatok',
  'tool.askQuestion': 'Kérdés',
  'tool.askQuestionSubmit': 'Beküldés',
  'tool.askQuestionPending': 'Várjuk a válaszodat',
  'tool.askQuestionAnswered': 'Megválaszolva',
  'tool.todosExpand': 'Feladatok mutatása',
  'tool.todosCollapse': 'Feladatok elrejtése',
  'tool.todosDone': 'Kész',
  'tool.todosDismiss': 'Feladatlista elvetése',
  'tool.write': 'Írás',
  'tool.edit': 'Szerkesztés',
  'tool.read': 'Olvasás',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Lekérés',
  'tool.search': 'Keresés',
  'tool.lines': '{n} sor',
  'tool.changeSingular': 'változás',
  'tool.changePlural': 'változás',
  'tool.in': 'itt: {path}',
  'tool.hide': 'elrejtés',
  'tool.output': 'kimenet',
  'tool.running': 'fut…',
  'tool.error': 'hiba',
  'tool.done': 'kész',

  'assistant.role': 'Asszisztens',
  'assistant.workingLabel': 'Dolgozik',
  'assistant.doneLabel': 'Kész',
  'assistant.feedbackPrompt': 'Visszajelzés',
  'assistant.feedbackPositive': 'Hasznos',
  'assistant.feedbackNegative': 'Nem hasznos',
  'assistant.feedbackReasonTitle': 'Tell us why',
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Missed my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual quality needs work',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add a short note...',
  'assistant.feedbackReasonSubmit': 'Submit',
  'assistant.emptyResponseLabel': 'No output',
  'assistant.emptyResponseMessage': 'The provider ended the request without returning text or an artifact. Try another model or provider, check quota, or retry.',
  'assistant.unfinishedLabel': 'Befejezetlen munkával állt le',
  'assistant.unfinishedSummary': '{n} feladat hátravan',
  'assistant.unfinishedMore': '+{n} további',
  'assistant.continueRemaining': 'Hátralévő feladatok folytatása',
  'assistant.outTokens': '{n} ki',
  'assistant.producedFiles': 'A körben létrehozott fájlok',
  'assistant.openFile': 'Megnyitás',
  'assistant.downloadFile': 'Letöltés',
  'assistant.thinking': 'Gondolkodik',
  'assistant.systemReminder': 'Rendszer-emlékeztető',
  'assistant.waitingFirstOutput': 'Az első kimenetre vár',
  'assistant.statusBootingAgent': 'Ügynök indítása',
  'assistant.statusStarting': 'Indítás',
  'assistant.statusRequesting': 'Kérés küldése',
  'assistant.statusThinking': 'Gondolkodik',
  'assistant.statusStreaming': 'Streamelés',
  'assistant.slowHint':
    'Tovább tart a szokásosnál. Az űrlap általában 5–10 mp alatt megjelenik — leállíthatod és újrafogalmazhatod.',
  'assistant.verbEditing': 'Szerkesztés',
  'assistant.verbWriting': 'Írás',
  'assistant.verbReading': 'Olvasás',
  'assistant.verbSearching': 'Keresés',
  'assistant.verbRunning': 'Futtatás',
  'assistant.verbTodos': 'Feladatok',
  'assistant.verbFetching': 'Lekérés',
  'assistant.verbCalling': 'Hívás',

  'qf.answered': 'megválaszolva',
  'qf.choose': 'Válassz…',
  'qf.required': 'kötelező',
  'qf.lockedSubmitted':
    'Válaszok elküldve — az ügynök ezeket használja a folyamat további részében.',
  'qf.lockedPrev': 'Ez az űrlap egy korábbi körből származik.',
  'qf.hint':
    'Válaszd, ami illik. Hagyd ki az opcionális mezőket, amik nem érdekesek — az ügynök ésszerű alapértékeket használ.',
  'qf.submitDefault': 'Válaszok küldése',
  'qf.submitDisabledTitle': 'Előbb töltsd ki a kötelező mezőket',
  'qf.submitTitle': 'Válaszok küldése',
  'qf.cardSelected': 'kiválasztva',
  'qf.cardRefs': 'Hivatkozások:',
  'qf.cardSampleText': 'Árvíztűrő tükörfúrógép · 0123',

  'sketch.toolSelect': 'Kijelölés (nem aktív)',
  'sketch.toolPen': 'Toll',
  'sketch.toolText': 'Szöveg',
  'sketch.toolRect': 'Téglalap',
  'sketch.toolArrow': 'Nyíl',
  'sketch.toolEraser': 'Radír',
  'sketch.color': 'Szín',
  'sketch.strokeSize': 'Vonalvastagság',
  'sketch.undo': 'Visszavonás',
  'sketch.clear': 'Törlés',
  'sketch.close': 'Bezárás',
  'sketch.closeConfirm': 'Bezárod a vázlatot, és elveted a nem mentett változtatásokat?',
  'sketch.textPrompt': 'Szöveg:',
  'sketch.textModalTitle': 'Szöveg hozzáadása',

  'pet.title': 'Háziállatok',
  'pet.subtitle': 'Fogadj be egy apró társat, aki a munkaterületed felett lebeg.',
  'pet.navTitle': 'Háziállatok',
  'pet.navHint': 'Befogadás vagy testreszabás',
  'pet.tabBuiltIn': 'Beépített',
  'pet.tabBuiltInHint': 'Az Design Appnal csomagolt társak — válassz egyet és fogadd örökbe.',
  'pet.builtInEmpty': 'A beépített állatok most nem elérhetők. Frissítsd a Közösség fület, amint a daemon újra online.',
  'pet.tabCustom': 'Egyéni',
  'pet.tabCustomHint': 'Készíts sajátot névvel, jellel, színnel vagy sprite-tal.',
  'pet.tabCommunity': 'Közösségi',
  'pet.tabCommunityHint': 'Codex-ben kikelt háziállatok — fogadj be egyet, vagy generálj újat.',
  'pet.tabsAria': 'Háziállat forrása',
  'pet.adopt': 'Befogadás',
  'pet.adoptedBadge': 'Befogadva',
  'pet.adoptCallout': 'Fogadj be egy háziállatot',
  'pet.changePet': 'Háziállat váltása',
  'pet.wake': 'Ébresztés',
  'pet.tuck': 'Elrejtés',
  'pet.wakeTitle': 'Háziállat ébresztése — lebegő réteg megjelenítése.',
  'pet.tuckTitle': 'Háziállat elrejtése — lebegő réteg eltüntetése.',
  'pet.settingsTitle': 'Háziállat beállításainak megnyitása',
  'pet.useCustom': 'Saját háziállat használata',
  'pet.customTitle': 'Készíts egy sajátot',
  'pet.customHint': 'Válassz nevet, jelet és kiemelőszínt — a réteg élőben frissül.',
  'pet.customGreetingPlaceholder': 'Köszönj a háziállatod nevében…',
  'pet.fieldName': 'Név',
  'pet.fieldGlyph': 'Jel',
  'pet.fieldGlyphHint': 'Egyetlen emoji a legjobb (pl. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Üdvözlés',
  'pet.fieldAccent': 'Kiemelőszín',
  'pet.fieldAccentCustom': 'Egyedi szín',
  'pet.fieldAccentDefault': 'Alapértelmezett kiemelőszín',
  'pet.overlayAria': 'Háziállat társ',
  'pet.spriteAria': '{name} — húzd a mozgatáshoz, kattints a beszélgetéshez',
  'pet.spriteTitle': 'Üdv tőlem, {name}! Kattints a beszélgetéshez.',
  'pet.composerTitle': 'Háziállatok — ébresztés, elrejtés vagy választás',
  'pet.composerMenuTitle': 'Háziállatok',
  'pet.composerMenuHint': 'tipp: írd be /pet a váltáshoz',
  'pet.composerOpenSettings': 'Háziállatok kezelése',
  'pet.welcomeTeaserTitle': 'Fogadj be egy háziállatot',
  'pet.welcomeTeaserBody': 'Egy apró lebegő társ, aki veled van.',
  'pet.welcomeTeaserCta': 'Választok egyet',
  'pet.imageUpload': 'Sprite feltöltése',
  'pet.imageReplace': 'Sprite cseréje',
  'pet.imageRemove': 'Emoji használata',
  'pet.imageHintIdle':
    'PNG, JPG, WebP, GIF vagy SVG. Spritesheet? Tölts fel egy vízszintes szalagot, és add meg a képkockaszámot.',
  'pet.imageHintActive':
    'A sprite-od látható. Állítsd a képkockaszámot 1 fölé egy vízszintes spritesheet animálásához.',
  'pet.fieldFrames': 'Képkockák',
  'pet.fieldFramesHint': '1 = statikus. > 1 = vízszintes spritesheet.',
  'pet.fieldFps': 'Sebesség (fps)',
  'pet.fieldFpsHint': 'Milyen gyorsan forognak a képkockák.',
  'pet.atlasImport': 'Codex sprite importálása',
  'pet.atlasImportTitle': 'Importálj egy hatch-pet 8x9 / 192x208 atlast (PNG vagy WebP).',
  'pet.atlasPickerTitle': 'Válassz animációs sort',
  'pet.atlasPickerHint':
    'A Codex háziállatok 9 animációs sort hoznak. Alapból a teljes atlast használjuk, így a háziállat sort vált hover, húzás és tétlen állapot szerint. Egy sorra is rögzíthető.',
  'pet.atlasCancel': 'Atlas eldobása',
  'pet.atlasAdopt': 'Rögzítés erre a sorra',
  'pet.atlasAdoptFull': 'Teljes atlas használata (animált)',
  'pet.atlasAdoptFullTitle':
    'Minden sor megmarad, így a háziállat reagál a hoverre, a húzás irányára és a hosszú tétlenségre.',
  'pet.atlasAdoptRowTitle':
    'Csak a kiemelt sort vágjuk ki egy ismétlődő szalaggá.',
  'pet.atlasActiveHint':
    'Animált atlas aktív — a háziállat az interakcióid (hover, húzás, tétlen) alapján választ sort.',
  'pet.atlasRow.idle': 'Tétlen',
  'pet.atlasRow.running-right': 'Futás jobbra',
  'pet.atlasRow.running-left': 'Futás balra',
  'pet.atlasRow.waving': 'Integetés',
  'pet.atlasRow.jumping': 'Ugrás',
  'pet.atlasRow.failed': 'Sikertelen',
  'pet.atlasRow.waiting': 'Várakozás',
  'pet.atlasRow.running': 'Futás',
  'pet.atlasRow.review': 'Áttekintés',
  'pet.hatchTitle': 'Új háziállat költése MI-vel',
  'pet.hatchHint':
    'Használd a beépített hatch-pet skillt a chatben egy Codex-stílusú spritesheet generálásához, majd importáld ide.',
  'pet.hatchConcept': 'Háziállat-koncepció (opcionális)',
  'pet.hatchConceptPlaceholder': 'pl. egy apró pixel-art shiba kötött pulóverben',
  'pet.hatchCopy': 'Prompt másolása',
  'pet.hatchCopied': 'Kimásolva!',
  'pet.hatchFoot':
    'Miután a skill elmentette a háziállatot, gyere vissza és válaszd a „Codex sprite importálása" lehetőséget.',
  'pet.slashPopoverAria': 'Slash parancsok',
  'pet.slashPopoverTitle': 'Parancsok',
  'pet.slashPopoverHint': '↑↓ navigáció · enter választás · esc kilépés',
  'pet.slashPet': 'Háziállat váltása, befogadása vagy a beállítások megnyitása.',
  'pet.slashPetWake': 'Lebegő háziállat-réteg ébresztése.',
  'pet.slashPetTuck': 'Háziállat elrejtése egy időre.',
  'pet.slashHatch': 'Codex háziállat generálása a hatch-pet skill-lel.',
  'pet.slashHatchArg': '<koncepció>',
  'pet.slashSearch': 'Webes keresés az OD research paranccsal.',
  'pet.slashSearchArg': '<keresés>',
  'pet.codexTitle': 'Frissen kikelt',
  'pet.codexSubtitle':
    'A hatch-pet skill által csomagolt háziállatok itt jelennek meg, egy kattintással befogadhatók.',
  'pet.codexSubtitleWithDir': '{dir} keresése hatch-pet csomagok után.',
  'pet.codexEmpty': 'Még nincs kikelt háziállat. Írd be /hatch a chatbe egy generálásához.',
  'pet.codexLoading': 'Kikelt háziállatok keresése…',
  'pet.codexRefresh': 'Frissítés',
  'pet.codexAdopt': 'Befogadás',
  'pet.codexAdopting': 'Befogadás folyamatban…',
  'pet.communitySync': 'Közösségi háziállatok letöltése',
  'pet.communitySyncing': 'Letöltés…',
  'pet.communitySyncTitle':
    'Frissítsd a Codex Pet Share és j20 Hatchery legutóbbi háziállatait a ~/.codex/pets/ mappába.',
  'pet.communitySyncDone': '{wrote} új háziállat szinkronizálva (összesen {total}).',
  'pet.communitySyncFailed': 'A szinkronizálás sikertelen: {error}',
  'pet.codexBundled': 'Beépített',
  'pet.codexBundledTitle': 'Az Design Appgal érkezik — letöltés nem szükséges.',

  'settings.notifications': 'Értesítések',
  'settings.notificationsHint': 'Hang és asztali értesítés a feladat befejezésekor',
  'settings.notifyCompletionSound': 'Befejezési hang',
  'settings.notifyCompletionSoundHint': 'Megszólal egy kör végén. Alapértelmezetten kikapcsolva.',
  'settings.notifySuccessSound': 'Sikerhang',
  'settings.notifyFailureSound': 'Hibahang',
  'settings.notifyDesktop': 'Asztali értesítés',
  'settings.notifyDesktopHint': 'Akkor érkezik, ha az ablak nem aktív.',
  'settings.notifyDesktopBlocked': 'A böngésző letiltotta. Engedélyezd a webhely beállításaiban.',
  'settings.notifyDesktopUnsupported': 'Az asztali értesítések ebben a környezetben nem elérhetők.',
  'settings.notifyTest': 'Tesztküldés',
  'settings.notifyTestSent': 'Tesztértesítés elküldve. Ha nem jelenik meg banner, ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifyTestFailed': 'Az értesítéshívás sikertelen. Ellenőrizd a böngésző és a rendszer értesítési beállításait.',
  'settings.notifySoundDing': 'Csilingelés',
  'settings.notifySoundChime': 'Csengő',
  'settings.notifySoundTwoToneUp': 'Kétszólamú emelkedő',
  'settings.notifySoundPluck': 'Pengetés',
  'settings.notifySoundBuzz': 'Zümmögés',
  'settings.notifySoundTwoToneDown': 'Kétszólamú ereszkedő',
  'settings.notifySoundThud': 'Tompa puffanás',
  'settings.skills': 'Készségek',
  'settings.skillsHint': 'Funkcionális készségek, amelyeket az ügynök egy feladat közben hívhat',
  'settings.skillsNew': 'Új készség',
  'settings.skillsEmpty': 'Válassz egy készséget balra, vagy hozz létre újat.',
  'settings.skillsEdit': 'Szerkesztés',
  'settings.skillsDelete': 'Törlés',
  'settings.skillsDeleteConfirm': 'Törlés megerősítése',
  'settings.skillsName': 'Név',
  'settings.skillsTriggers': 'Indítók (vesszővel vagy új sorral elválasztva)',
  'settings.skillsDescription': 'Leírás',
  'settings.skillsBody': 'SKILL.md tartalom',
  'settings.skillsCreate': 'Létrehozás',
  'settings.skillsSave': 'Mentés',
  'settings.skillsSaving': 'Mentés…',
  'settings.skillsFiles': 'Fájlok',
    'settings.skillsNoFiles': 'Nincs fájl ebben a készségmappában.',
  'settings.skillsNameRequired': 'A készség neve kötelező.',
  'settings.skillsBodyRequired': 'A készség tartalma kötelező.',
  'settings.designSystems': 'Designrendszerek',
  'settings.designSystemsHint': 'Böngészd és kapcsold be az elérhető designrendszereket',
  'settings.designSystemsInstalled': 'Telepítve',
  'settings.designSystemsAdd': 'Designrendszer hozzáadása',
  'settings.designSystemsHiddenCount': '{count} elrejtve a kezdő galériából',
  'settings.designSystemsShowAll': 'Összes megjelenítése',
  'settings.designSystemsShowHidden': 'Rejtettek megjelenítése',
  'settings.designSystemsSource': 'Forrás',
  'settings.designSystemsSourceLocal': 'Helyi',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsStructure': 'Struktúra',
  'settings.designSystemsModeHybrid': 'Hibrid',
  'settings.designSystemsModeNormalized': 'Normalizált',
  'settings.designSystemsModeVerbatim': 'Változatlan',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Szín',
  'settings.designSystemsCraftAccessibility': 'Akadálymentesség',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'Projekt útvonala',
  'settings.designSystemsImportGithub': 'Importálás GitHubból',
  'settings.designSystemsImportProject': 'Importálás projektből',
  'settings.designSystemsImportedStatus': '{title} importálva',
  'settings.designSystemsViewImported': 'Importált designrendszer megtekintése',
  'settings.designSystemsCategory': 'Kategória',
  'settings.designSystemsAllCategories': 'Minden kategória',
  'settings.designSystemsShowInHomeGallery': 'Megjelenítés a kezdő galériában',
  'settings.librarySkills': 'Készségek',
  'settings.libraryDesignSystems': 'Tervezőrendszerek',
  'settings.librarySearch': 'Keresés...',
  'settings.libraryAll': 'Összes',
  'settings.libraryPreview': 'Előnézet',
  'settings.libraryPreviewClose': 'Bezárás',
  'settings.libraryLoading': 'Betöltés...',
  'settings.libraryNoResults': 'Nincs a keresésnek megfelelő elem.',
  'settings.libraryEnabled': 'Engedélyezve',
  'settings.libraryDisabled': 'Letiltva',
  'settings.connectorsNavHint': 'Külső rendszerek kapcsolatai',
  'settings.connectorsHint': 'Kezeld az eszköz csatlakozó- és eszközszolgáltató-beállításait.',
  'settings.connectorsSavedTitle': 'Helyi daemonban mentve',
  'settings.connectorsSavedWithTail': 'Mentve · ••••{tail}',
  'settings.connectorsSaved': 'Mentve',
  'settings.connectorsReplaceKeyPlaceholder': 'Illessz be új kulcsot a mentett cseréjéhez',
  'settings.connectorsHelpEmpty': 'Composio integrations are managed by your workspace.',
  'settings.autosaveSaving': "Mentés…",
  'settings.autosaveSaved': "Minden változtatás mentve",
  'settings.autosaveError': "A változtatások mentése nem sikerült. A helyi daemon offline lehet.",
  'settings.libraryToggleLabel': 'Átváltás',
  // Memory (auto-extracted personalization saved as on-disk markdown)
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'Design App v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Útvonal másolva',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'Megnyitás',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.libraryInstall': 'Telepítés',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Helyi elérési út',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Telepítés',
  'settings.libraryUninstall': 'Eltávolítás',
  'settings.libraryBuiltIn': 'Beépített',
  'settings.libraryInstalled': 'Telepítve',
  'notify.successTitle': 'Feladat befejezve',
  'notify.failureTitle': 'A feladat meghiúsult',
  'notify.successBody': 'Egy kör befejeződött.',
  'notify.failureBody': 'A feladat hibával ért véget.',
  'updater.available': 'Frissítés érhető el',
  'updater.availableBody': 'Az Design App {version} elérhető. A telepítő megnyitása előtt letöltődik.',
  'updater.checking': 'Frissítések keresése',
  'updater.download': 'Frissítés letöltése',
  'updater.downloading': 'Frissítés letöltése',
  'updater.downloadingPercent': 'Frissítés letöltése {percent}%',
  'updater.done': 'Kész',
  'updater.failed': 'A frissítés sikertelen',
  'updater.installerOpenBody': 'A telepítő meg van nyitva. Az Design App kilép, hogy befejezhesse a frissítést.',
  'updater.installerOpened': 'Telepítő megnyitva',
  'updater.later': 'Később',
  'updater.openFailedFallback': 'A telepítő nem nyitható meg.',
  'updater.openInstaller': 'Frissítés telepítése',
  'updater.opening': 'Telepítő megnyitása...',
  'updater.quitButton': 'Kilépés az Design Appból',
  'updater.quitFailedBody': 'A telepítő meg van nyitva, de az Design App nem tudott kilépni. Az alkalmazás cseréje előtt lépjen ki az Design Appból.',
  'updater.quitFailedTitle': 'Nem sikerült kilépni',
  'updater.quitting': 'Kilépés...',
  'updater.ready': 'Frissítés kész',
  'updater.readyGeneric': 'Elkészült az új verzió. Az Design App bezárul, és megnyitja a telepítőt.',
  'updater.readyVersion': 'Az Design App {version} elkészült. Az Design App bezárul, és megnyitja a telepítőt.',
  'updater.upToDate': 'Már a legújabb verziót használja.',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatizálás',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Napi csatlakozó-összefoglaló',
  'settings.orbit.lede': 'Gyűjtsd a csatlakozók aktivitását ütemezetten, és tedd közzé az eredményt frissíthető live artifact formában.',
  'settings.orbit.statusOnTitle': 'Az ütemezett napi futások be vannak kapcsolva',
  'settings.orbit.statusOffTitle': 'Az ütemezett napi futások ki vannak kapcsolva',
  'settings.orbit.statusActive': 'Aktív',
  'settings.orbit.statusOff': 'Ki',
  'settings.orbit.runTitle': 'Orbit futás indítása és az élő beszélgetés megnyitása',
  'settings.orbit.running': 'Fut…',
  'settings.orbit.runOpen': 'Futtatás most',
  'settings.orbit.dailySummaryTitle': 'Napi összefoglaló',
  'settings.orbit.dailySummarySub': 'Naponta egyszer fut a beállított helyi időben.',
  'settings.orbit.on': 'Be',
  'settings.orbit.off': 'Ki',
  'settings.orbit.runTimeTitle': 'Futási idő',
  'settings.orbit.runTimeSub': 'Alapértelmezett 08:00. Mentés után érvényesül a daemon ütemezésében.',
  'settings.orbit.runTimeAria': 'Napi Orbit futási idő',
  'settings.orbit.nextRun': 'Következő futás',
  'settings.orbit.nextRunScheduledAfterSave': 'Mentés után ütemezve',
  'settings.orbit.schedule': 'Ütemezés',
  'settings.orbit.pausedManualOnly': 'Szüneteltetve — csak kézi futások',
  'settings.orbit.templateTitle': 'Prompt sablon',
  'settings.orbit.templateMissing': 'A(z) {id} sablon nincs telepítve.',
  'settings.orbit.templateMissingOption': '{id} (hiányzik)',
  'settings.orbit.templateMissingInstall': 'Telepíts Orbit skillt a prompt irányításához.',
  'settings.orbit.templateMissingPickAnother': 'Válassz másik sablont a legördülőből.',
  'settings.orbit.templateResetTitle': 'Visszaállítás erre: {id}',
  'settings.orbit.templateReset': 'Visszaállítás',
  'settings.orbit.templateHelp': 'Irányítsd az Orbit működését skillel — a kiválasztott sablon példa promptja bekerül minden Orbit futásba, hogy az összefoglalók a sablon formáját kövessék.',
  'settings.orbit.templateAria': 'Orbit prompt sablon',
  'settings.orbit.templatesLoading': 'Sablonok betöltése…',
  'settings.orbit.templatesOptgroup': 'Orbit skill sablonok',
  'settings.orbit.lastRun': 'Utolsó futás',
  'settings.orbit.triggerManual': 'Kézi',
  'settings.orbit.triggerScheduled': 'Ütemezett',
  'settings.orbit.meterAria': '{succeeded} sikeres, {skipped} kihagyva, {failed} sikertelen, összesen {checked} ellenőrizve',
  'settings.orbit.countChecked': 'Ellenőrizve',
  'settings.orbit.countSucceeded': 'Sikeres',
  'settings.orbit.countSkipped': 'Kihagyva',
  'settings.orbit.countFailed': 'Sikertelen',
  'settings.orbit.runError': 'Nem sikerült futtatni az Orbit műveletet. Ellenőrizd, hogy a helyi daemon fut-e, és a csatlakozók be vannak-e állítva.',
  'settings.orbit.gateAriaLabel': "Az Orbit használatához csatlakozók szükségesek",
  'settings.orbit.gateEyebrow': "Beállítás szükséges",
  'settings.orbit.gateTitle': "Csatlakoztass egy eszközt az Orbit működéséhez",
  'settings.orbit.gateBody': "Az Orbit összefoglalja a csatlakozók tevékenységét. Még nem csatlakoztattál semmit — adj hozzá legalább egy integrációt, hogy az Orbitnak legyen miről jelentenie.",
  'settings.orbit.gateBodyNoKey': "Az Orbit a csatlakozóid tevékenységét összegzi, és a csatlakozók a Composio-n keresztül futnak. Adj hozzá egy Composio API-kulcsot a Csatlakozók alatt, hogy feloldd a katalógust és kiválaszthasd az első integrációd.",
  'settings.orbit.gateAction': "Csatlakozók megnyitása",
  'settings.orbit.gateActionNoKey': "Composio beállítása",
  'settings.orbit.gateLoading': "Csatlakozók ellenőrzése…",
  'settings.orbit.controlsLockedBadge': "Zárolva",
  'settings.orbit.controlsLockedHint': "Csatlakoztass egy eszközt az Orbit ütemezésének és sablonjának feloldásához.",
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Régi összefoglaló',
  'settings.orbit.artifactTitle': 'Napi Orbit aktivitási összefoglaló',
  'settings.orbit.artifactMetaLive': 'Csatlakozó-aktivitásból generált frissíthető HTML artifact.',
  'settings.orbit.artifactMetaLegacy': 'A live artifact támogatás engedélyezése előtt készült — futtasd újra az Orbit műveletet egy közzétételéhez.',
  'settings.orbit.copyMarkdownTitle': 'Markdown összefoglaló másolása a vágólapra',
  'settings.orbit.copied': 'Másolva',
  'settings.orbit.copy': 'Másolás',
  'settings.orbit.openArtifact': 'Artefakt megnyitása',
  'settings.orbit.sourceMarkdown': 'Forrás Markdown',
  'liveArtifact.viewer.tabPreview': 'Előnézet',
  'liveArtifact.viewer.tabCode': 'Kód',
  'liveArtifact.viewer.tabData': 'Adatok',
  'liveArtifact.viewer.tabRefreshHistory': 'Frissítési előzmények',
  'liveArtifact.viewer.dataEmpty': 'Nincs elérhető data.json gyorsítótár.',
  'liveArtifact.viewer.code.templateHeading': 'Sablon HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Renderelt HTML',
  'liveArtifact.viewer.code.templateHelp': 'A data.json fájllal az előnézet létrehozásához használt szerkeszthető sablon.',
  'liveArtifact.viewer.code.renderedHelp': 'Az előnézet által jelenleg betöltött generált index.html.',
  'liveArtifact.viewer.code.variantAria': 'Kódváltozat',
  'liveArtifact.viewer.code.variantTemplate': 'Sablon',
  'liveArtifact.viewer.code.variantRendered': 'Renderelt',
  'liveArtifact.viewer.code.loading': 'Kód betöltése…',
  'liveArtifact.viewer.code.unavailable': 'A kód még nem érhető el.',
  'liveArtifact.viewer.code.empty': 'Ez a kódfájl üres.',
  // Diagnostics export
  'diagnostics.exportTitle': 'Diagnosztika exportálása',
  'diagnostics.exportButton': 'Diagnosztika exportálása',
  'diagnostics.exportHint': 'A legutóbbi alkalmazásnaplókat és gépinformációkat zip fájlba csomagolja a csapatnak való elküldéshez.',
  'diagnostics.exporting': 'Exportálás…',
  'diagnostics.exportSuccess': 'Diagnosztika mentve: {path}',
  'diagnostics.exportFailed': 'Diagnosztika exportálása sikertelen: {message}',
};
